import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import produce, { immerable } from 'immer';
import { Map } from 'immutable';

import { GroupingTagItemEntity } from '../../domain/grouping-tag-item.entity';

export type IGroupingTagListExtra = IListColumnConfig<GroupingTagItemEntity>;

interface IGroupingTagListEntity extends IListAttrs<GroupingTagItemEntity> {
	availableColumns: Map<string, IGroupingTagListExtra>;
	totalItems: number;
}

const entityDefaults: IGroupingTagListEntity = {
	elements: Map(),
	availableColumns: Map(),
	totalItems: 0,
};

export class GroupingTagListEntity
	implements
		IGroupingTagListEntity,
		IListOperations<GroupingTagListEntity, GroupingTagItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;
	public totalItems = entityDefaults.totalItems;

	public static build(
		availableCols: Array<IGroupingTagListExtra>
	): GroupingTagListEntity {
		const instance = new GroupingTagListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IGroupingTagListExtra]>());
		instance.availableColumns = Map(cols);
		return instance;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<GroupingTagItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(
		elems: Map<string, GroupingTagItemEntity>
	): GroupingTagListEntity {
		return produce(this, (draft: GroupingTagListEntity) => {
			draft.elements = elems;
		});
	}

	public setTotalItems(total: number): GroupingTagListEntity {
		return produce(this, (draft: GroupingTagListEntity) => {
			draft.totalItems = total;
		});
	}
}
